import { Tooltip } from "@zapier/design-system-beta";

// Not using tooltip content empty string since it leave a thin black line
export const ConditionalTooltip = ({
  content,
  children,
  isViewOnlyMode,
}: {
  content: string;
  children: React.ReactNode;
  isViewOnlyMode: boolean;
}) => {
  if (isViewOnlyMode) {
    return <>{children}</>;
  }

  return (
    <Tooltip placement="top" content={content}>
      <Tooltip.FocusableTrigger>{children}</Tooltip.FocusableTrigger>
    </Tooltip>
  );
};
